import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
@connect( store => {
    return {
        conversations: store.conversations,
        project: store.project,
        notes: store.notes,
        conversation:store.conversation,
        socket: store.socket.container,
        task: store.task,
        loggedUser: store.loggedUser
    }
})

class Actions extends React.Component {
    constructor(props) {
        super(props);

        _.map(
            ["onSubmit", "onSend","parseMention","fetchTaskDetails","isMessageEmpty"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    fetchTaskDetails() {
        const { dispatch, task, loggedUser } = this.props;
        const url = `api/task/detail/${task.Selected.id}`;
        const params = {
            starredUser: loggedUser.data.id
        }
        Axios.get(url, params)
        .then(response => {
            if (response) {
                dispatch({ type: "SET_TASK_SELECTED", Selected: response.data });
            } else {
                showToast('error', c.data.message);
            }
        })    
      
    }

    onSubmit() {
        const { conversation, task, loggedUser, dispatch, type, section } = this.props;
        const actionData = conversation.Actions[type];
        
        const fileIds = task.SectionFiles[section] && task.SectionFiles[section].length ? task.SectionFiles[section].map(e => {
            return e.document.id
        }) : [];

         let mentionIds=[]
          if(this.IsJsonString(actionData.message)){
            mentionIds = this.parseMention(fields.message).map(u=>u.url)
          }
          const typeReplyParams = this.props.type === "reply" ? {
            type: this.props.type,
            commentGroup: actionData.replyTo
        } : {};
          const params = {
            data: { 
                comment: actionData.comment, 
                linkType: "task", 
                linkId: task.Selected.id, 
                usersId: loggedUser.data.id 
            },
            reminderList: _.uniq(mentionIds),
            taskId: task.Selected.id,
            projectId: task.Selected.projectId,
            userId: loggedUser.data.id,
            fileTagIds: fileIds,
            workstreamId: task.Selected.workstreamId,
            ...typeReplyParams
        }
        
        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
        const url = "/api/conversation/comment";
        Axios.post(url, params)
            .then(response => {
                if (response) {    
                    if(this.props.type === "reply") {
                        dispatch({ type: "SET_NEW_COMMENT_LIST", list: conversation.List.map(c => {
                            if(c.id === response.data.result.id) {
                                return {...c, reply: response.data.result.reply};
                            }
        
                            return c;
                        })});
                    } else {
                        dispatch({ type: "UPDATE_COMMENT_LIST", comment: response.data.result });
                    }
    
                    this.fetchTaskDetails();
    
                    dispatch({ type: "SET_ACTION_COMMENTS", action: type, data: {} });
                    dispatch({ type: "CLEAR_TASK_SECTION_FILES", section: section });
                    dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    $(`#${this.props.section}-clear-comment-upload`).click();
                } else {
                    dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    showToast("error", "Something went wrong. Please try again later.");
                }        
            });
    }
    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }

        return true;
    }
    onSend() {
        const { dispatch, conversations, project,files, conversation, notes } = this.props;
        const fields = conversations.fields;
        const groupId = conversations.selectedMsg?conversations.selectedMsg.id:null
         let mentionId=[]
          if(this.IsJsonString(fields.message)){
            mentionId = this.parseMention(fields.message).map(u=>u.url)
          }
          console.log("groupId",groupId)
        const params = {
            comment: typeof fields.message === 'string'? fields.message: "",
            projectId: project.Selected.id,
            documentIds: conversations.forUpload.map(f=>f.id),
            workstreamIds: conversations.selected.tagged_workstreams_notes.map( w => w.workstream.id ),
            mentionedUsers:mentionId,
            users: conversations.selected.tagged_users.map( w => w.user.id ),
            linkId: conversations.selected.id,
            commentGroup:groupId
        }
        
        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        Axios.post('api/conversation/sendMessage', params)
            .then(response => {
                if( response ) {  
                 
                    // dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: [...conversations.selectedMessages, response.data] });
                    dispatch({ type: "UPDATE_CONVERSATIONS_ACTION_TYPE", action: "formSubmit" });
                    dispatch({ type: "CLEAR_CONVERSATIONS_FIELDS" });
                }
                const docs = [...response.data.conversationDocuments, ...conversations.selected.notesTagDoc]               
                dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
                dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
                dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: { ...conversations.selected, 
                    notesTagDoc:docs,
                    unread: 0,
                    total_count: conversations.selected.total_count+1} });
                dispatch({ type: "CONVERSATION_TOBE_CLEAR" });
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {}});
                $('.insert_upload').remove()
                $(".conversation-modal .conversation-list.hasScroll").css("max-height","calc(100vh - 500px)")
                setTimeout(() => {
                    const ht = $('#divElement').prop('scrollHeight')
                    $('#divElement').animate({
                        scrollTop: ht+500
                    }, 2000);      
                   
                }, 100);
                $('.conversation-message').removeClass('active')
                if(conversations.latestMessages.length > 0){
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: [...conversations.latestMessages, response.data] });
                    dispatch({ type: "SET_CONVERSATIONS_LATEST", list: []})

                }
                Axios.post(
                    `api/conversation/seen`,
                    {
                        noteId: conversations.selected.id,
                        projectId: project.Selected.id,
                        //conversationIds: response.data.result.map(c=>c.id)
                    }
                ).then(result => {
                    if (result.data) {
                        const count = conversation.ConversationCount
                        dispatch({ type: "SET_CONVERSATION_COUNT", count: count<1?0: count- 1 })
                       
                    }
                })
                
            });
    }
   
    parseMention(message){
        const obj = JSON.parse(message)
        const mention = Object.keys(obj.entityMap)
        .map(o=>obj.entityMap[o])
        .filter(f=>f.type ==='MENTION')
        .map(m=>m.data)
        return mention
        
    }
    isMessageEmpty(message){
        try {
           const obj = JSON.parse(message)
           if(obj.blocks.length === 1 && !obj.blocks[0].text) {
              return 0
           } 
               return message.length
        }  catch(error){
            return 0
        }
      
      }
    render() {
        const { conversation, task, loggedUser, dispatch, type, section } = this.props;
        const handleSubmit = () => {
            if(this.props.submit) {
                this.props.submit()  
            } else {
                this.onSubmit();  
            }
            this.props.onAction()
         
        }
        return (
            <div class="toolbar-buttons action-buttons">
                <ul>
                    <li>
                        <a class={`sendBtn  ${this.props.isEnabled?'active':''}`} onClick={ handleSubmit }>Send</a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default Actions;